const joinUrlPath = (...segments) => segments.join('/').replace(/\/\/+/g, '/');

const PUBLIC_ASSETS_PATH = '/assets/ssr/';
const INTERNAL_ASSETS_ROOT = process.env.INTERNAL_ASSETS_ROOT || '/assets/';
const AMPLITUDE_API_KEY = process.env.AMPLITUDE_API_KEY || 'unknown';
const INTERNAL_ASSETS_PATH = joinUrlPath(INTERNAL_ASSETS_ROOT, '/ssr/');

// The ssr-supervisor knobs. They are read by the supervisor, by the server
// bundle it forks and by the webpack config it drives, which is three processes
// with three chances to disagree about what the same variable means.
const SSR_HOT_RELOAD = process.env.SSR_EXPERIMENTAL_HOT_RELOAD === '1';
const SSR_DEV_RELOAD = process.env.SSR_DEV_RELOAD !== '0';
// Ceilings, not reservations: V8 grows into these only if the work demands it,
// and the point is to bound the worst case rather than to divide a fixed pool.
// The watcher keeps the image-wide default because the client build measurably
// needs it — capped at 1536 it OOMs mid-compile and leaves the asset directory
// empty, which is not a smaller footprint but a broken container. The worker is
// where there is room to take some back: it no longer compiles the client
// bundle in-process, it only renders, at half of what production allows it.
const SSR_WATCH_HEAP_MB = Number(process.env.SSR_WATCH_HEAP_MB) || 4096;
const SSR_WORKER_HEAP_MB = Number(process.env.SSR_WORKER_HEAP_MB) || 2048;

module.exports = {
  GTM_CONTAINER_ID: 'GTM-T7QFMT',
  GTM_EXTRA_PARAMS: '',
  EVENTSTREAM_LIB_PATH: joinUrlPath(PUBLIC_ASSETS_PATH, '/eventstream-v0.0.13.js'),
  PUBLIC_ASSETS_PATH,
  INTERNAL_ASSETS_PATH,
  AMPLITUDE_API_KEY,
  SSR_HOT_RELOAD,
  SSR_DEV_RELOAD,
  SSR_WATCH_HEAP_MB,
  SSR_WORKER_HEAP_MB,
};
